export interface Post {
    title: string
    summary: string
    slug?: string
    keywords?:string[]
    date: Date
  }

  export const benefitsList: Post[]=[

    {
      title: 'Wondering why your child can remember all parts of a movie or cartoon but not mathematics?',
      summary: "",
      keywords: ["Mathematics is cumulative subject","why your children fail mathematics","arouse curiosity in maths","use math daily"],
      date: new Date('2021-12-15'),
    },
    {
      title: 'Should you blend technology with traditional learning?',
      summary: "",
      keywords: ["Instant math feedback","use mathematics words and concepts in everyday activities","arouse curiosity in maths","shopping and mathematics"],
      date: new Date('2021-12-15')
    },

    {
      title: "Are you relying on one teacher for your child's dream in mathematics?",
      summary: "",
      keywords: ["Not every teacher is comfortable in all areas of the curriculum","use additional math resources to support your children","arouse curiosity in maths","Boldungu technology solutions  creates math variety of verified, tested and certified math content"],
      date: new Date('2021-12-15')
    },
    {
      title: "Are you effectively managing your child's skills growth in mathematics?",
      summary: "",
      keywords:['Mathematics concepts build on each','continuously monitor and evaluate student progress in mathematics','most learners can excel in mathematics'],
      date: new Date('2021-12-15')
    }
  ]

  export const featuredList: Post[]=[
    {
      title: 'Five Engaging Activities to Master Addition Skills',
      summary: "Addition lays the foundation for mathematical understanding and is a crucial skill for children to develop. By making addition fun and interactive, kids can build confidence and fluency in this fundamental operation. Let's explore five engaging activities that will help your child master addition skills while having a blast",
      date: new Date('2024-02-28'),
    },

    {
      title: 'Interactive Activities to Master Fractions with Ease',
      summary: "Fractions can sometimes seem like a daunting concept for kids, but with the right approach, learning about fractions can be both enjoyable and rewarding",
      date: new Date('2024-01-27'),
    },

    {
      title: 'Engaging Probability Activities for School Children',
      summary: "Probability, a fundamental concept in mathematics, doesn't have to be confined to the classroom. With a bit of imagination and some everyday materials, you can introduce your child to the fascinating world of probability right at home or outdoors",
      date: new Date('2024-01-27'),
    },

    {
      title: 'Turn mathematics problem solving for primary school children into a conversation',
      summary: "Vocabulary is the body of words one can use effectively to communicate in a given language. Our research shows that learners in lower classes find difficulty in using common mathematics words such as “altogether”, “diameter”, “profit” and many others, which makes it impossible for them to workout the correct answers.",
      date: new Date('2021-01-27'),
    },
    {
      title: 'Five Main reasons why primary school children continue to fail mathematics',
      summary: "A Problem Well Stated is Half Solved”. These words by Charles Kettering, who was head of research at General Motors from 1920 to 1947, are still valid.",
      date: new Date('2020-12-23'),
    },
    {
      title: 'Number sense is the secret weapon for children that excel in mathematics',
      summary: "Many things that we take to be obvious are a result of mental modals that we build as a result of consistent exposure. It is this lack of mental models that when a baby presented with two cakes will not be able to tell which one is bigger.",
      date: new Date('2020-10-11')
    },

    {
      title: 'Injecting fun into probability and chance for primary school mathematics',
      summary: "Many events happen in a random, unpredictable nature. The study of probability for primary school children in many countries including Uganda therefore forms a basis for understating nature. Probability is applied in many disciplines including statistics, meteorology, game theory and risk analysis among others",
      date: new Date('2020-10-11')
    }
  ]
  export const entries: Post[] = [


    {
      title: "Reasons parents say they like Boldungu to boost their children Mathematics Grades",
      summary: "",
      date: new Date()
    },

   {
    title:"A tool to practice mathematics beyond homework",
    summary: "",
    date: new Date("2020-09-11")
  },

   {
    title: "Boldungu origin revealed as bold and adungu for fun",
    summary: "",
    date: new Date("2020-09-11")
  }
  ];
